module.exports = __webpack_public_path__ + "img/RBCFND_LogoDes_H_rgbPE.dd08e58b.png";